import React, { useEffect } from "react";
import { HashRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Login from '../pages/login/login';
import ProtectedRoute from '../routes/protectedRoute';
import Main from '../pages/main/main';
import Home from '../pages/home/home';
import Company from "../pages/company/company";
import Vessels from "../pages/vessels/vessels";
import Incidents from "../pages/incidents/incidents";
import Reports from "../pages/reports/reports";
import GridStatus from "../pages/gridStatus/gridStatus";
import Registers from "../pages/registers/registers";
import Energy from "../pages/energy/energy";
import Emissions from "../pages/emissions/emissions";
import Users from "../pages/users/users";

/**
 * Retorna el título adecuado para la pestaña del navegador según la ruta actual.
 * @param pathname - Ruta actual del navegador.
 * @param t - Función de traducción de i18next.
 * @returns El título correspondiente a la ruta.
 */
const getPageTitle = (pathname: string, t: (key: string) => string): string => {
    switch (pathname) {
        case '/':
            return 'The Power Port';
        case '/SmartPort/Home':
            return t('menu.home');
        case '/SmartPort/Company':
            return t('menu.company');
        case '/SmartPort/Vessels':
            return t('menu.vessels');
        case '/SmartPort/Incidents':
            return t('menu.incidents');
        case '/SmartPort/Reports':
            return t('menu.reports');
        case '/SmartPort/GridStatus':
            return t('menu.gridStatus');
        case '/SmartPort/Registers':
            return t('menu.registers');
        case '/SmartPort/Energy':
            return t('menu.energy');
        case '/SmartPort/Emissions':
            return t('menu.emissions');
        case '/SmartPort/Users':
            return t('menuUser.users');
        default:
            return 'Validar';
    }
};

/**
 * Componente que gestiona el enrutamiento de la aplicación y actualiza el título del documento.
 */
function RoutesApp() {
    const location = useLocation();
    const { t } = useTranslation();

    useEffect(() => {
        document.title = getPageTitle(location.pathname, t);
    }, [location.pathname, t]);

    return (
        <>
            <Routes>
                <Route path='/' element={<Login />} />
                <Route element={<ProtectedRoute />}>
                    <Route path='/SmartPort' element={<Main />}>
                        <Route path='Home' element={<Home />} />
                        <Route path='Company' element={<Company />} />
                        <Route path='Vessels' element={<Vessels />} />
                        <Route path='Incidents' element={<Incidents />} />
                        <Route path='Reports' element={<Reports />} />
                        <Route path='GridStatus' element={<GridStatus />} />
                        <Route path='Registers' element={<Registers />} />
                        <Route path='Energy' element={<Energy />} />
                        <Route path='Emissions' element={<Emissions />} />
                        <Route path='Users' element={<Users />} />
                    </Route>
                </Route>
            </Routes>
        </>
    );
}

export default function RootApp() {
    return (
        <Router>
            <RoutesApp />
        </Router>
    );
}